import type React from 'react';
import { createContext, useContext, useMemo } from 'react';
import useMainHooks from '../hooks/use-main-hooks';

type DiagramContextValue = {
  isAIGenerated: boolean;
  isNewDiagram: boolean;
  isSavedDiagram: boolean;
  diagramId: string | null;
  recordId: string | null;
};

interface DiagramContextProps {
  children: React.ReactNode;
}

const DiagramContext = createContext<DiagramContextValue | undefined>(undefined);

export const DiagramContextProvider: React.FC<DiagramContextProps> = ({ children }: DiagramContextProps) => {
  const { isAIGenerated, isNewDiagram, isSavedDiagram, diagramId, recordId } = useMainHooks();

  const value = useMemo(
    () => ({ isAIGenerated, isNewDiagram, isSavedDiagram, diagramId, recordId }),
    [isAIGenerated, isNewDiagram, isSavedDiagram, diagramId, recordId]
  );
  return <DiagramContext.Provider value={value}>{children}</DiagramContext.Provider>;
};

// context consumer hook
export const useDiagramContext = () => {
  const context = useContext(DiagramContext);

  if (context === undefined) {
    throw new Error('useDiagramContext must be used within DiagramContextProvider');
  }

  return context;
};
